import { makeAutoObservable } from 'mobx';
import { OverviewType } from '../DUMEvents/DUMEvents.store';
export interface IDumFilter {
  year: {
    from?: number;
    end?: number;
  };
  location?: number;
  contries?: string[];
  ecosystem?: number[];
  anomalyRating?: number[];
}
export interface IAdvanceFilterStore {
  show: boolean;
  filters: IDumFilter;
  allYears: number[];
  initialize: boolean;
  setAllYears: (allYear: OverviewType) => void;
  resetFilter: () => void;
}

const defaultFilter: IDumFilter = {
  year: {
    from: undefined,
    end: undefined
  },
  location: undefined,
  contries: undefined,
  ecosystem: Array.from({ length: 4 }, (_v, k) => k),
  anomalyRating: undefined
};

export class AdvanceFilterStore implements IAdvanceFilterStore {
  show = false;
  filters: IDumFilter = defaultFilter;
  allYears: number[] = [];
  initialize = false;
  constructor() {
    makeAutoObservable(this);
  }

  setAllYears(overviewData: OverviewType) {
    if (this.allYears.length === 0) {
      let years = overviewData.map((v) => v.year).filter(Boolean);
      years = years.filter(
        (value, index, array) => array.indexOf(value) === index
      );
      years.sort((a, b) => a - b);
      this.allYears = years;

      this.filters.year = {
        from: this.allYears[0],
        end: this.allYears[this.allYears.length - 1]
      };
    }
  }

  resetFilter() {
    this.filters = defaultFilter;
  }
}

export const AdvanceFilterStoreDefault: IAdvanceFilterStore = {
  show: false,
  filters: {
    year: {
      from: undefined,
      end: undefined
    },
    location: 1,
    contries: undefined,
    ecosystem: undefined,
    anomalyRating: undefined
  },
  allYears: [],
  initialize: false,
  setAllYears: () => {
    // set all years
  },
  resetFilter: () => {
    // reset all filters
  }
};
